import React, { useState, useCallback, useLayoutEffect, useRef } from 'react';

var getDirection = function getDirection(prev, next, vertical) {
  if (vertical === void 0) {
    vertical = true;
  }

  if (!prev || prev === next) return 'none';
  if (next > prev) return vertical ? 'down' : 'right';
  return vertical ? 'up' : 'left';
};

var useChangeVisibility = function useChangeVisibility(props) {
  var onVisibilityChange = props.onVisibilityChange,
      targetRef = props.targetRef,
      _props$distance = props.distance,
      distance = _props$distance === void 0 ? 0 : _props$distance;

  var _useState = useState({}),
      previos = _useState[0],
      setPrevios = _useState[1];

  var onVisibleCallback = useCallback(function (entries) {
    var _entries$ = entries[0],
        visible = _entries$.isIntersecting,
        _entries$$boundingCli = _entries$.boundingClientRect,
        y = _entries$$boundingCli.y,
        x = _entries$$boundingCli.x;
    if (visible === previos.visible) return;
    var directionY = getDirection(previos.y, y);
    var directionX = getDirection(previos.x, x, false);
    setPrevios({
      visible: visible,
      x: x,
      y: y
    });
    onVisibilityChange({
      visible: visible,
      directionX: directionX,
      directionY: directionY
    });
  }, [onVisibilityChange, previos]);
  useLayoutEffect(function () {
    if (!targetRef.current) return;
    var observer = new IntersectionObserver(onVisibleCallback, {
      root: null,
      rootMargin: distance + "px",
      threshold: 0
    });
    observer.observe(targetRef.current);
    return function () {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, [onVisibleCallback, targetRef.current, distance]);
};

var VisibilityDetector = function VisibilityDetector(props) {
  var className = props.className,
      onVisibilityChange = props.onVisibilityChange,
      children = props.children,
      _props$distance = props.distance,
      distance = _props$distance === void 0 ? 0 : _props$distance;
  var targetRef = useRef(null);
  useChangeVisibility({
    onVisibilityChange: onVisibilityChange,
    targetRef: targetRef,
    distance: distance
  });
  return React.createElement("div", {
    ref: targetRef,
    className: className
  }, children);
};

var VisibilityDetector$1 = /*#__PURE__*/React.memo(VisibilityDetector);
export default VisibilityDetector$1;
export { useChangeVisibility };